import { useState } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import type { Rating } from '@/components/shared/QualityFeedback';

interface UseAIQuestionFeedbackResult {
  isSubmitting: boolean;
  rating: Rating;
  onRate: (clicked: 'positive' | 'negative') => void;
}

// AIDEV-NOTE: Rates a whole generation batch, keyed to its LLMCompletion (the AI event). Clicking the
// active thumb toggles it off (rating -> null), which the backend treats as clearing the feedback.
const useAIQuestionFeedback = (
  assessmentID: number | null,
  llmCompletionID: number | null,
): UseAIQuestionFeedbackResult => {
  const [rating, setRating] = useState<Rating>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onRate = (clicked: 'positive' | 'negative') => {
    if (assessmentID === null || llmCompletionID === null) return;

    const nextRating: Rating = rating === clicked ? null : clicked;
    const previousRating = rating;
    setRating(nextRating);
    setIsSubmitting(true);

    axios
      .post(Routes.plato_api_feedback_ai_question_builder_index_path(), {
        assessment_id: assessmentID,
        llm_completion_id: llmCompletionID,
        rating: nextRating,
      })
      .then(({ data }) => {
        setRating(data.rating);
      })
      .catch(() => {
        setRating(previousRating);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return { isSubmitting, onRate, rating };
};

export default useAIQuestionFeedback;
